export default __webpack_public_path__ + "static/media/74.0d827d72.gif";